import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import {
  modalDisplayDataShape,
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { currentSelectedNetwork } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
// import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import { modalOptionsShape } from 'AppSrc/core/components/forms/modal-options';
import { getDisplayOptionsToUse } from 'AppSrc/core/components/forms/data/get-display-options-to-use';
// form fields
import { workInformationType } from './work-information-type';
import { attachedFile } from './attached-file';
import { summary } from './summary';
import { dateAdded } from './date-added';
import './work-information-item.css';
import {
  WORK_INFORMATION_TYPE,
} from './work-information-item-constants';
import {
  isWitHumanCreatable,
  isAttachmentMadatory,
} from './work-information-item-logic';

// Title for the modal
const sectionTitle = 'Attachment details';
// All of the available fields, this is needed so that the FormSection can instantiate with the currect initial values



const filterWIT = ({
  componentData,
  network,
  formData,
}) => {

  const allDisplayOptions = getDisplayOptionsToUse({
    componentData,
    selectedNetwork: network,
  });


  const filteredDisplayOptions = [];

  allDisplayOptions.forEach((categoryObj) => {
    const newCategoryObj = {
      category: categoryObj.category,
      values: [],
    };
    categoryObj.values.forEach((displayOption) => {
      const displayOptionValue = displayOption.value;
      const witIsHumanCreatable = isWitHumanCreatable({
        selectedNetwork: network,
        workInfoItemType: displayOptionValue,
        formData,
      });
      if (witIsHumanCreatable) {
        newCategoryObj.values.push(displayOption);
        return null;
      }
      return null;
    });
    if (newCategoryObj.values.length > 0) {
      filteredDisplayOptions.push(newCategoryObj);
      return null;
    }
    return null;
  });

  return filteredDisplayOptions;
};
const checkfun = ((e) => {
  let cx = false;
  if (e) {
    cx = true;
    return cx;
  }
  return false;
});


// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {
  const {
    values = {},
    formData = {},
    // touched = {},
    // userRoles,
    sectionId,
    // the form that exists outside of the modal form
    outerFormData,
  } = params;

  // formik doesn't have access to some state on first render so we set that state to null;
  const CrqId = outerFormData ? outerFormData.crqId : null;
  const currentForm = sectionId ? formData.dataByFormSectionId[sectionId] : null;
  const workInfoItemId = currentForm ? currentForm.workInfoItemId : null;
  const network = outerFormData ? currentSelectedNetwork(outerFormData) : null;


  const selectedWorkInformationType = values[WORK_INFORMATION_TYPE];
  const attachmentMandatory = network ? isAttachmentMadatory(network, selectedWorkInformationType) : false;
  const filteredWit = network ? filterWIT({
    componentData: workInformationType,
    network,
    formData: outerFormData,
  }) : [];

  // if there is no outer form data, we shouldn't set an empty array as the display options
  // this will allow getCrq to use the default display options instead
  const displayOptions = outerFormData ? filteredWit : null;


  const currentFields = [];
  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...workInformationType,
      displayOptions,
    },
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: summary,
  });
  // Hide work attachment component if this is an existing work info item
  currentFields.push({
    ...defaultFieldLogic,
    componentData: attachedFile,
    optional: !attachmentMandatory,
    shouldRender: !workInfoItemId,
    crqID: CrqId,
    checkfun,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: dateAdded,
  });

  return currentFields;
};


// generates the formSection!
const WorkInformationItemModal = React.memo(({
  handleSuccessfulSubmit,
  // userRoles, // <- currently not passed in but may be needed to one day (maybe through redux?)
  formData,
  outerFormData,
  modalOptions,
  modalDisplayData,
  editingStatus,
}) => (
  <FormSection
    sectionTitle={sectionTitle}
    sectionId={modalDisplayData.sectionId}
    getCurrentFields={getCurrentFields}
    // userRoles={userRoles} <- I don't think this is currently passed in.
    formData={formData}
    outerFormData={outerFormData}
    modalOptions={modalOptions}
    handleSuccessfulSubmit={(data) => {
      // data to submit should include any existing workInfoItemId
      const { workInfoItemId } = modalDisplayData;
      const dataToSubmit = {
        ...data,
        workInfoItemId,
      };
      handleSuccessfulSubmit(dataToSubmit);
    }}
    editingStatus={editingStatus}
  />
));


WorkInformationItemModal.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  modalDisplayData: modalDisplayDataShape,
  // userRoles: userRolesPropShape,
  formData: formDataShape,
  outerFormData: formDataShape,
  modalOptions: modalOptionsShape,
  editingStatus: PropTypes.string,
};

const WORK_INFORMATION_ITEM_MODAL = 'WORK_INFORMATION_ITEM_MODAL';

export {
  getCurrentFields,
  WorkInformationItemModal,
  WORK_INFORMATION_ITEM_MODAL,
};
